/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const regenerateChallengeComparisonsV1ResultSchema = z.object({
  computed: z.number(),
  deleted: z.number(),
  total: z.number(),
});

export type IRegenerateChallengeComparisonsV1Result = z.infer<
  typeof regenerateChallengeComparisonsV1ResultSchema
>;

export const regenerateChallengeComparisonsV1ResponseSchema = createApiResponseSchema(
  regenerateChallengeComparisonsV1ResultSchema,
) as z.ZodSchema<IAPI<IRegenerateChallengeComparisonsV1Result>>;

export type IRegenerateChallengeComparisonsV1Response =
  IAPI<IRegenerateChallengeComparisonsV1Result>;
